export type ButtonTypes = "solid" | "outline" | "text"

export enum ButtonFontSizes {
  L = "l",
  S = "s",
  XS = "xs",
}

export interface ButtonCoreProps {
  type: ButtonTypes
  text: string
  disabled?: boolean
  loading?: boolean
  onClick?: () => void
  color?: string
  fontSize?: ButtonFontSizes
}

export interface ButtonSolidProps extends Omit<ButtonCoreProps, "type"> {}

export interface ButtonOutlineProps extends Omit<ButtonCoreProps, "type"> {}

export interface ButtonTextProps extends Omit<ButtonCoreProps, "type"> {}
